import React from 'react';
import { NavLink } from 'react-router-dom';
import { Box, Card, CardActionArea, CardContent, Paper, Stack, Typography } from '@mui/material';

function ToolsHome() {
  return (
    <Paper sx={{ p: 3, borderRadius: 3, border: '1px solid', borderColor: 'divider' }}>
      <Stack spacing={2}>
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 700 }}>
            Choose a tool
          </Typography>
          <Typography color="text.secondary">Select a QR or barcode generator from the list.</Typography>
        </Box>
        <Stack spacing={2}>
          <Card variant="outlined" sx={{ borderRadius: 2 }}>
            <CardActionArea component={NavLink} to="/qr" sx={{ p: 2.5 }}>
              <CardContent sx={{ p: 0 }}>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  QR Generator
                </Typography>
                <Typography color="text.secondary">
                  Build QR data for text, Wi-Fi, contact cards, and more.
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
          <Card variant="outlined" sx={{ borderRadius: 2 }}>
            <CardActionArea component={NavLink} to="/barcode" sx={{ p: 2.5 }}>
              <CardContent sx={{ p: 0 }}>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  Barcode Generator
                </Typography>
                <Typography color="text.secondary">
                  Create common 1D barcode formats with color controls.
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Stack>
      </Stack>
    </Paper>
  );
}

export default ToolsHome;
